// Camera positions for different option tabs/views
export const tabCameraPositions: Record<string, { position: [number, number, number], target: [number, number, number] }> = {
  // Screenshot-focused presets (used via ?camera=...)
  'side-left': {
    // Straight left side view
    position: [-25, 10, 0],
    target: [0, 2, 0],
  },
  'side-right': {
    // Straight right side view
    position: [25, 10, 0],
    target: [0, 2, 0],
  },
  'side-left-30': {
    "position": [
        -30.02244814897954,
        10.20575801112384,
        32.49513835074748
    ],
    "target": [
        0.5211404334962486,
        2.226468596646646,
        -0.535208052467528
    ]
},
  'side-right-30': {
    "position": [
        30.02244814897954,
        10.20575801112384,
        32.49513835074748
    ],
    "target": [
        0.5211404334962486,
        2.226468596646646,
        -0.535208052467528
    ]
},

  legs: {
    position: [8, 1, 9.9],
    target: [2, 0, 2]
  },
  'bedside-tables': {
    position: [
      15.075817423655174,
      3.743689760105805,
      11.969975119495436
    ],
    target: [
      4.808270558160166,
      -0.9076880727329141,
      -5.47514355654201
    ]
  },
  toppers: {
    position: [
      9.89103217402144,
      7.1377742169524625,
      10.721658301936513
    ],
    target: [
      0.11753825117300487,
      0.7434431005057549,
      0.7058723723827371
    ]
  },
  textiles: {
    "position": [
        11.457707954635715,
        4.48091477280228,
        18.288138647344677
    ],
    "target": [
        0.8244834974525838,
        -1.1267689462946535,
        0.5955222120670702
    ]
},
  accessories: {
    position: [
      16.751544110287654,
      11.383228845497323,
      29.37302546958334
    ],
    target: [
      -0.6351815192331904,
      2.251052465678671,
      0.4022621649749572
    ]
  },
  headboards: {
    "position": [
        3.7192986069886014,
        6.144495024898145,
        7.974187567982222
    ],
    "target": [
        1.3893144116208211,
        4.406386973788173,
        -1.5939969020206113
    ]
  },
  ottomans: {
    // Default position for ottomans view - adjusted to match mobile (lower camera)
    position: [0, 8, 30],
    target: [0, -2, 0]
  }
  // Add more tab positions here as needed
}

// Mobile-specific camera positions (adjusted for smaller screens)
export const tabCameraPositionsMobile: Record<string, { position: [number, number, number], target: [number, number, number] }> = {
  headboards: {
    // Zoom out quite a bit for mobile
    position: [
      12,
      12,
      25
    ],
    target: [
      1.3893144116208211,
      2,
      -1.5939969020206113
    ]
  },
  ottomans: {
    // Move camera down (lower Y position) for mobile
    position: [0, 8, 30],
    target: [0, -2, 0]
  }
}

/**
 * Get camera position for a tab, adjusted for mobile if needed
 * @param tabName - The name of the tab/view
 * @param isMobile - Whether the device is mobile (< 768px width)
 * @returns Camera position and target
 */
export function getTabCameraPosition(tabName: string, isMobile: boolean): { position: [number, number, number], target: [number, number, number] } | undefined {
  if (isMobile && tabCameraPositionsMobile[tabName]) {
    return tabCameraPositionsMobile[tabName]
  }
  return tabCameraPositions[tabName]
}

